import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';



const ProfileFilingStatus = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);
    const [filing_status, setFilingStatus] = useState(null);
    const [user, setUser] = useState(null);

    useEffect(() => {

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getFilingStatuss();
        getUser();

    }, []);

    const getFilingStatuss = async (e) => {
        axios.get(process.env.REACT_APP_API_URL + "/get-filing-statuses", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setFilingStatus(response?.data?.filingstatues);



                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }

    const getUser = async (e) => {
        axios.get(process.env.REACT_APP_API_URL + "/get-user", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setUser(response?.data?.user);



                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });


    }

    const saveFilingStatus = async (e) => {
        setIsBtn(true);
        setErrorResponse(null);

        const { filing_status_id } = user;
        if (!filing_status_id) {
            setIsBtn(false)
        } else {


            await axios.post(process.env.REACT_APP_API_URL + "/save-filing-status", {
                filing_status_id: user.filing_status_id,
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {
                    setIsBtn(false)
                    if (response?.data?.status) {

                        navigate("/profile");



                    } else {

                        setErrorResponse(response?.data?.message);

                    }
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };


    const backToProfile = async (e) => {
        navigate("/profile")
    };

    return (


        <>

            <div className="title-box">

                <div className="flex-equal justify-content-start " >
                    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToProfile} >

                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
                        </svg>
                        <label >Back</label>

                    </button>

                </div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Filing Status</h3>
                <div className="flex-equal justify-content-end" ></div>

            </div>



            <div className="box" >

                <div className="form-content p-32 align-items-start" >

                    {errorResponse &&
                        <div className="fs-14  color-white" role="alert">
                            {errorResponse}
                        </div>
                    }


                    {user && filing_status && filing_status.map((o, index) => {
                        return <div className="input-text" onClick={(e) => setUser({ ...user, filing_status_id: o.filing_status_id })} >

                            <label className="color-light fs-14">
                                <input type="radio" className="color-light fs-14" id="filing_status_{index}"
                                    name="filing_status_{index}" value={o.filing_status_id}
                                    checked={user.filing_status_id == o.filing_status_id}

                                />
                                {o.filing_status_name}

                            </label>


                        </div>
                    })}

                </div>
            </div>

            <div className="form-action">

                <div className="action-bar ">

                    <div className="button-box">

                        <button className=" btn btn-secondary" type="button" onClick={backToProfile}>Cancel</button>
                        <button className="btn btn-primary" type="button" onClick={saveFilingStatus} disabled={isBtn}>
                            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>

                    </div>
                </div>

            </div>



        </>


    );
};

export default ProfileFilingStatus;